import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { handleApi } from "../../../utils/authentication";
import { toast } from "react-toastify";
import { Outlet } from "react-router-dom";
import LoadingSpinner from "../../../components/client/LoadingSpinner";

const Dashboards = () => {
  const [client, setClient] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state?.user);

  const getClientData = async () => {
    try {
      setIsLoading(true);
      let client_id = user?.client_id;
      if (client_id) {
        let method = "POST";
        let headers = {};
        let formdata = new FormData();
        formdata.append("client_id", client_id);
        let result = await handleApi(`view_client`, method, headers, formdata);
        if (result?.success) {
          setClient(result?.data?.client_info);
        } else {
          // toast.error("Failed to load customer details");
          return;
        }
      }
    } catch (e) {
      console.log(e);
      toast.error(e?.message || "Failed to load customer details");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getClientData();
  }, []);

  return (
    <div className="position-relative">
      {isLoading && <LoadingSpinner />}
      <Outlet />
    </div>
  );
};

export default Dashboards;
